export const ApprovalFolderName: string = "ToBeApproved";